var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(-294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    transform: "translate(294)",
    fill: "none",
    stroke: "#1e1f28",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(302 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(3.46)",
    fill: "#1f2828",
    stroke: "#1f2828",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.08,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.08,
    height: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    transform: "translate(8 3.46) rotate(90)",
    fill: "#1f2828",
    stroke: "#1f2828",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.08,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.08,
    height: 7,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plusCircle.134d830c.svg";
export { ForwardRef as ReactComponent };